import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../assets/i18n/de.json';
import { FattenerService } from './services/fattener.service';
import { FattenerRepository } from './repositories/fattener.repository';
import { DefaultValueRepository } from './repositories/default-value.repository';
import { DefaultValueService } from './services/default-value.service';
import { DefaultValuePayloadService } from './services/default-value-payload.service';
import { ReportRepository } from './repositories/report.repository';
import { ReportService } from './services/report.service';
import { StableRepository } from './repositories/stable.repository';
import { StableService } from './services/stable.service';

export const gewichtsportalProviders: (Provider | EnvironmentProviders)[] = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'gewichtsportal',
      language: 'de',
      translations: de,
    });
  }),
  FattenerRepository,
  FattenerService,
  DefaultValueRepository,
  DefaultValueService,
  DefaultValuePayloadService,
  ReportRepository,
  ReportService,
  StableRepository,
  StableService,
];
